// extracted by mini-css-extract-plugin
export default {"section":"DonateCta_section_G_41L","panel":"DonateCta_panel_iQ07k","title":"DonateCta_title_z9l1s","text":"DonateCta_text_FBA47","button":"DonateCta_button_MODH0"};